import { createContext, useContext, Dispatch, SetStateAction } from 'react'

export interface AuthState {
  isWebinarAdmin: boolean,
  setIsWebinarAdmin: Dispatch<SetStateAction<boolean>>,
  isModerator: boolean,
  setIsContentEditor: Dispatch<SetStateAction<boolean>>,
  isContentEditor: boolean,
  setIsModerator: Dispatch<SetStateAction<boolean>>
}

export const INITIAL_STATE: AuthState = {
  isWebinarAdmin: false,
  setIsWebinarAdmin: () => void 0,
  isModerator: false,
  setIsContentEditor: () => void 0,
  isContentEditor: false,
  setIsModerator: () => void 0
}

export const AuthContext = createContext(INITIAL_STATE)

export const useAuthContext = () => useContext(AuthContext)
